<template>
  <div class="stage">
    <img class="stage__room" :src="roomSrc" alt="" :style="roomStyle" />
    <div class="stage__cat" :style="catStyle">
      <assistant-cat-home-idle-cat :writer-type="writerType" :cat-name="catName" @tap-burst="$emit('tap-burst', $event)" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import AssistantCatHomeIdleCat from "@/components/organisms/assistantCatHome/AssistantCatHomeIdleCat.vue";
import { AssistantCatHomeLayout, layoutBoxStyle } from "@/constants/assistantCatHomeLayout";
import { assistantCatHomeRoomSrc } from "@/constants/assistantCatHome";
import { AssistantCatGroup } from "@/lib/models/assistantCat";

export default Vue.extend({
  name: "AssistantCatHomeStage",
  components: {
    AssistantCatHomeIdleCat,
  },
  props: {
    group: {
      type: String as () => AssistantCatGroup,
      required: true,
    },
    writerType: {
      type: String,
      default: null,
    },
    catName: {
      type: String,
      default: "",
    },
    layout: {
      type: Object as () => AssistantCatHomeLayout,
      required: true,
    },
  },
  computed: {
    roomSrc(): string {
      return assistantCatHomeRoomSrc(this.group as AssistantCatGroup);
    },
    roomStyle(): Record<string, string> {
      const { roomLeft, roomTop, roomSize } = this.layout;
      return layoutBoxStyle(roomLeft, roomTop, roomSize, roomSize);
    },
    catStyle(): Record<string, string> {
      const { catLeft, catTop, catW, catH } = this.layout;
      return layoutBoxStyle(catLeft, catTop, catW, catH);
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.stage {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.stage__room {
  position: absolute;
  display: block;
  object-fit: contain;
  opacity: 0.8;
  pointer-events: none;
}

.stage__cat {
  position: absolute;
  overflow: visible;
  pointer-events: auto;
}
</style>
